import jsonLd from './functions/_jsonLd'
import salonPage from './functions/salonPage'

export default function JsonLdSalon ({ salon }) {
    return jsonLd(salonPage(salon))
}